import $ from 'jquery'

let currentScrollY
let previousScrollY = 0
let directionScroll
let unscrolled
let ticking = false

let unscrolledTrigger
let unscrolledTriggerTop

function checkUnscrolled(scrollY) {

    let unscrolledNow = scrollY < unscrolledTriggerTop
    directionScroll = scrollY - unscrolledTriggerTop - previousScrollY

    if (unscrolledNow && !unscrolled) {
        $(document).trigger('pub:unscrolled')
    }
    if (!unscrolledNow && unscrolled) {
        $(document).trigger('pub:scrolled')
    }

    $(document).trigger('pub:scrolling')





    if (directionScroll < 0) {
        $(document).trigger('pub:scrolling:up')
    } else {
        $(document).trigger('pub:scrolling:down')
    }

    unscrolled = unscrolledNow
    previousScrollY = scrollY
}

function observeUnscrolled() {
    currentScrollY = window.scrollY

    unscrolledTrigger = $('.article-content').offset()

    if (unscrolledTrigger) {
        unscrolledTriggerTop = unscrolledTrigger.top - 100
    } else {
        unscrolledTriggerTop = 1
    }
    unscrolled = currentScrollY < unscrolledTriggerTop

    window.addEventListener('scroll', function (e) {

        currentScrollY = window.scrollY

        if (!ticking) {
            window.requestAnimationFrame(function () {
                checkUnscrolled(currentScrollY)
                ticking = false
            })
            ticking = true
        }



        if ($("body").hasClass("single-magazine")) {
            let adminBarOffset = 0;
            if ($("body").hasClass("admin-bar")) {
                adminBarOffset = 30;
            }
            // console.log("magazine page!")
            let footerObj = $(".c-pub-footers");
            let windowH = window.innerHeight;
            let footerY = footerObj.position().top - windowH;
            let footerOffset = window.scrollY - footerY - 125 - adminBarOffset;
            let hudObj = $(".hud.magazine");

            if (footerOffset > 0) {
                hudObj.height("calc(100% - " + footerOffset + "px)");
            } else {
                hudObj.height("100%");
            }
        }

    })

    //	//console.log(unscrolled)

    if (unscrolled) {
        $(document).trigger('pub:unscrolled')
    } else {
        $(document).trigger('pub:scrolled')
    }

}

export default observeUnscrolled

